import { faker } from '@faker-js/faker';
import dayjs from 'dayjs';
import { HttpHandler, HttpResponse, delay, http } from 'msw';

faker.seed(1);

const getExportFileMock = () => {
  const status = faker.helpers.arrayElement(['processing', 'done', 'failed']);
  return {
    id: faker.string.uuid(),
    content_type: faker.helpers.arrayElement([
      '書類送付案内作成',
      'レポート',
      'その他',
    ]),
    status,
    created_at: dayjs(faker.date.past()).format('YYYY/MM/DD'),
    updated_at: dayjs(faker.date.recent()).format('YYYY/MM/DD'),
    name: `書類送付案内_${faker.date.past().toISOString().split('T')[0]}.zip`,
    byte_size: faker.helpers.arrayElement(['', '4000', '1000000000']),
    office_member: { name: faker.person.fullName(), avatar: '' },
    error_message: (() => {
      if (status === 'processing' || status === 'pending') {
        return undefined;
      }
      return faker.helpers.arrayElement([
        '削除しました',
        'ダウンロードの有効期限が切れました',
        undefined,
      ]);
    })(),
    can_download: status === 'done',
    can_delete: status === 'done',
  };
};

const getSearchExportFilesMock = (page = 1, per_page = 25) => ({
  export_files: Array.from({ length: per_page }, () => getExportFileMock()),
  pagination: {
    has_next_page: true,
    has_previous_page: true,
    page: page,
    per_page: per_page,
    total_pages: 20,
    total_records: 500,
  },
});

const getDownloadUrlMock = () => ({
  presigned_url: `https://test-ap-temporary-resource-bucket.s3.ap-northeast-1.amazonaws.com/idev-ex-web-ap-web-neo-payable/ap_tempfile_796?response-content-disposition=attachment%3B%20filename%2A%3DUTF-8%27%27temp&X-Amz-Expires=3600&X-Amz-Date=20250624T035349Z&X-Amz-Security-Token=IQoJb3JpZ2luX2VjECwaDmFwLW5vcnRoZWFzdC0xIkcwRQIhAPOiINqFAzoJoGH5eu%2BO%2BqJ2BwT5fdcjdwsrOlEXaEPKAiAcKvbePD9r6Ezy6AoSfoub9YOFSzR4aWFGnsqxfE1rdyquBQglEAIaDDM2MTc3NTYyMTk5MiIMFxprHYXloYGvRjPdKosFKZO9JoLKmzv7vpswG7If3a842%2Bt5Af9uycH4hy9dL9IRjkKTYwwPWOGLGPe39Aii2ObqLJcEyeWe4NN1jXUxf2iBYz%2FcgvByRciEfzs%2BMvaJMpbXM6gt%2FSAGtY9YKBtYbU9n5V3%2FtySsNyduS3Yu1ROZZFcN05A2Afkc3HoBBS5T3puFB3iVXHBteegsuDZTARo6occ87ZOYIC1WwBWOGV%2BlknUZJQrXzMdM7jgq7jY9YEE1xt3m2Ws4K6bM5nmO6Oo8HWnD314b9ArMVR72B512wEdSztz5svBy%2BGDNbobyNXe739WTIuyho5cqM3EZCqdtxsIYggrGe76LexXrhVAY5xnQXnmZjo0JFQjLjlzu3iSWEZTnt%2FTWziS5VaNj%2BfcyCQ3TxipRrB7De%2Fk7Pa4H6ech3yX7JWobNjn1PpD9O7obH0yfGoGSjsQw2Fq6psgxQSYtvlLvhCwGbBTYsvr0JqXGHrvfesHtvEwNYzGJNtbloXJHLknbU3ZGJt2mUMPwAEwRqz7bzCla3Qa277YW%2BypwVjpg7wVsL1gdTmvGe75xMdfNDi6xeMBE0WoUILEFcORW3ExNT4Nguu%2F0ftOIPRNxg8znX0C5SoN2%2Bqnm55VZIjBxncsehmnr9OZPkotd4ESnJ9roiy8lhaEp9PiENB%2Btu2cw9MwaLB%2F73UZBXm7qVdsN7pa4peiRswWbs6%2BGBiymnofzxinLvgzV2OJyqd4j49cIuc25TGEnm1WMlVEdPreVP2i19Cu4TyT8mq5nWATpLFERhKKPIAC%2FPzIX9jOqtwCH7uMJBdCUs8Gbt91o9CGONno0ofSX%2B1HBxzbZpM3QmzBBGIzfHBtj8qRs0KEBNzvGu6%2F3MKfC6MIGOpsBTN8CV0CPjxOH6Ag%2FTHY%2F2gm11yXtgKeUfrhJzT8if7Plntwhj2kkbOVZWvg%2FBsJIIqcFxfqWmgUC6E5DQ0Z%2BzObPj7a4rYwOOZeQuXvOOJ6f%2B7QrZ%2BWMCB4Cbt0nD2tgNnipF1k0CzHuUTe71HeWk9H%2FqmVpjguV2o6jB1T%2FEXhE7T8A918MX%2BQnuSq0Fb9IdldIdZqG0qabahs%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAVIO4B45UOWXXB3ZJ%2F20250624%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-SignedHeaders=host&X-Amz-Signature=be1975e6ecc3040020f3c972fa8404552cba482d1339ebc5985cb7c8179602bd`,
});

export const handlers: HttpHandler[] = [
  http.post('*/api/js/export_files/search', async ({ request }) => {
    await delay(500);
    const reqBody = await request.json();
    let page = 1;
    let per_page = 25;
    if (
      reqBody &&
      typeof reqBody === 'object' &&
      'pagination' in reqBody &&
      reqBody.pagination
    ) {
      page = reqBody.pagination.page || 1;
      per_page = reqBody.pagination.per_page || 25;
    }
    return new HttpResponse(
      JSON.stringify(getSearchExportFilesMock(page, per_page)),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),

  http.get('*/api/js/export_files/:id/download', async ({ params }) => {
    await delay(300);
    const { id } = params;

    // Simulate some files not being available for download
    if (id && typeof id === 'string' && id.includes('error')) {
      return new HttpResponse(
        JSON.stringify({
          code: 'not_found',
          messages: ['File not found or access denied'],
        }),
        {
          status: 404,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }

    return new HttpResponse(JSON.stringify(getDownloadUrlMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
